import React from "react";
import {
    Paper,
    Typography,
} from '@mui/material';
import {ErrorOutline} from "@mui/icons-material";


export const SessionExpired = () => {
    return (
        <div className="page-layout">
            <>
                <Typography sx={{
                    fontSize: "1.5rem",
                    color: 'action.active',
                    marginTop: "2em"
                }}>Session Timed Out</Typography>
                <Paper elevation={0} sx={{
                    padding: "3em",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: 0
                }}>
                    <ErrorOutline sx={{
                        display: "inline-block",
                        fontSize: "5rem",
                        color: 'error.main'
                    }}/>
                    <div style={{
                        display: "inline-block",
                        marginLeft: "1em"
                    }}>
                        <Typography>
                  <span style={{
                      color: '#6B7280'
                  }}>
                    Your current session has timed out.
                  </span>
                            <div style={{
                                color: '#6B7280'
                            }}>
                                Please log in again to continue.
                            </div>
                        </Typography>
                    </div>
                </Paper>
            </>
        </div>
    );
};
